import type { FC } from "react";

const Footer: FC = () => {
  return (
    <footer className="py-1.5 px-4 text-left text-sm text-gray-500 border-t">
      &copy; {new Date().getFullYear()} Craig Admin
    </footer>
  );
};

export default Footer;
